














import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { ProductMetaList } from '@master/model/common/ProductMetaList'
import TheILP from '@core/components/basicRecommendation/TheILP.vue'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    TheILP
  }
})
export default class TheILPSubfunds extends Vue {
  @kycFormStore.State
  kycForm!: KYCForm;

@kycFormStore.State
  productMetaList: ProductMetaList

  @kycFormStore.Action
  private fetchRecommendedProducts!: () => void

  get ilpPortfolios () {
    return this.kycForm.newIlpPortfolios.ilpPortfolios
  }

  get rcmdIlpProducts () {
    return this.kycForm.recommendations.validBasicProduct
      .filter(product => product.productType?.toLowerCase().includes('ilp') ||
      product.productCategory?.toLocaleLowerCase().includes('investment-linked plan'))
  }

  get ilpFundList () {
    return this.productMetaList.getILPProductList()
  }

  saveIlp () {
    this.$emit('save')
  }

  created () {
    this.fetchRecommendedProducts()
  }
}
